import Reflux from 'reflux';

import actions from '../actions';

export default Reflux.createStore({
	listenables: actions,

	init() {
		this.state = {
			active: ['model'],
			selected: ['model']
		};
	},

	onToggleTab(index) {
		const i = this.state.selected.indexOf(index);
		if (i >= 0) {
			this.state.selected.splice(i, 1);
		} else {
			this.state.selected.push(index);
		}
		this.checkTabs(index);
		this.output();
	},

	onSelectTab(index) {
		if (this.state.selected.indexOf(index) < 0) {
			this.state.selected.push(index);
		}
		this.checkTabs(index);
		this.output();
	},

	onUnselectTab(index) {
		const i = this.state.selected.indexOf(index);
		if (i >= 0) {
			this.state.selected.splice(i, 1);
		}
		this.output();
	},

	checkTabs(index) {
		if (index === 'item') {
			const i = this.state.selected.indexOf('accessory');
			if (i >= 0) {
				this.state.selected.splice(i, 1);
			}
		} else if (index === 'accessory') {
			const i = this.state.selected.indexOf('item');
			if (i >= 0) {
				this.state.selected.splice(i, 1);
			}
		}
	},

	getState() {
		return this.state;
	},

	output() {
		this.trigger(this.getState());
	},

	getInitialState() {
		return this.getState();
	}
});
